<template>
  <div class="blog__card">
    <div v-show="editPost" class="icons">
      <div class="icon">
        <Edit class="edit" />
      </div>
      <div class="icon">
        <Delete class="delete" />
      </div>
    </div>
    <img
      :src="require(`../src/assets/blogCards/${post.blogCoverPhoto}.jpg`)"
      alt=""
    />
    <div class="info">
      <h4>{{ post.blogTitle }}</h4>
      <h6>كتب بتاريخ : {{ post.blogDate }} </h6>
      <router-link class="link" to="#">
        أقرأ المزيد <Arrow class="arrow" />
      </router-link>
    </div>
  </div>
</template>

<script>
import Arrow from "../src/assets/Icons/arrow-left-light.svg";
import Edit from "../src/assets/Icons/edit-regular.svg";
import Delete from "../src/assets/Icons/trash-regular.svg";

export default {
  name: "blogCard",
  props: ["post"],
  components: { Arrow, Edit, Delete },
  computed: {
    editPost() {
      return this.$store.state.editPost;
    },
  },
};
</script>

<style lang="scss" scoped>
.blog__card {
  position: relative;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  min-height: 420px;
  transition: 500ms ease all;
  border-radius: 0 0 8px 8px;

  &:hover {
    transform: rotateZ(-1deg) scale(1.01);
    box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.1),
      0 2px 4px -1px rgba(0, 0, 0, 0.06);
  }
  .icons {
    display: flex;
    position: absolute;
    top: 10px;
    z-index: 99;
    .icon {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 33px;
      height: 33px;
      border-radius: 50%;
      background-color: #fff;
      margin: 5px;

      &:hover {
        background-color: #303030;
        .edit,
        .delete {
          path {
            fill: #fff;
          }
        }
      }
      &:nth-child(1) {
        margin-right: 8px;
      }

      .edit,
      .delete {
        pointer-events: none;
        height: 15px;
        width: auto;
      }
    }
  }
  img {
    display: block;
    border-radius: 8px 8px 0 0;
    z-index: 1;
    width: 100%;
    min-height: 200px;
    object-fit: cover;
  }
  .info {
    display: flex;
    flex-direction: column;
    height: 100%;
    z-index: 3;
    padding: 32px 50px;
    color: #000;

    h4 {
      padding-bottom: 8px;
      font-size: 23px;
      font-weight: 300;
    }

    h6 {
      font-weight: 400;
      font-size: 15px;
      padding-bottom: 16px;
    }
    .link {
      display: inline-flex;
      align-items: center;
      margin-top: auto;
      font-weight: 500;
      padding-top: 20px;
      font-size: 14px;
      padding-bottom: 4px;
      transition: 500ms ease-in all;

      &:hover {
        color: rgba(48, 48, 48, 0.8);
      }

      .arrow {
        width: 17px;
      }
    }
  }
}
</style>
